import actionsProfile from "./actions";

export default {
  namespaced: false,
  actions: actionsProfile,
};
